import React from 'react';
import type { SubnicheOpportunity } from '../types';

const COMP_TONE: Record<SubnicheOpportunity['competition'], string> = {
  open:   'text-leaf-700',
  low:    'text-brand-700',
  medium: 'text-amber-700',
  high:   'text-slate-500',
};

const COMP_RULE: Record<SubnicheOpportunity['competition'], string> = {
  open:   'border-l-leaf-500',
  low:    'border-l-brand-500',
  medium: 'border-l-amber-500',
  high:   'border-l-slate-300',
};

const SubnicheOpportunities: React.FC<{ items: SubnicheOpportunity[] }> = ({ items }) => {
  if (!items || items.length === 0) return null;
  const top = items.slice(0, 6);
  return (
    <section className="py-4 border-b border-slate-200">
      <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
        <h3 className="text-[13px] font-semibold text-slate-900">サブニッチ戦略（勝てる戦場）</h3>
        <span className="text-[11px] text-slate-500">3-pack 圏内を3ヶ月以内に確保</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
        {top.map((n) => (
          <div key={n.niche} className={`border-l-2 ${COMP_RULE[n.competition]} pl-3`}>
            <div className="flex items-baseline justify-between mb-1 gap-2 flex-wrap">
              <h4 className="text-[13px] font-semibold text-slate-900">「{n.niche}」</h4>
              <span className={`text-[10px] font-semibold ${COMP_TONE[n.competition]}`}>{n.competition_label}</span>
            </div>
            <p className="text-[12px] text-slate-600 leading-relaxed mb-2">{n.description}</p>
            <div className="flex flex-wrap gap-x-3 text-[11px] text-slate-500">
              <span>推定検索 <strong className="text-slate-900 tabular-nums">{n.estimated_volume_monthly.toLocaleString()}/月</strong></span>
              <span>LTV指数 <strong className="text-slate-900 tabular-nums">×{n.ltv_index.toFixed(1)}</strong></span>
              <span>機会スコア <strong className="text-slate-900 tabular-nums">{n.opportunity_score}</strong></span>
            </div>
            {n.matched_competitors.length > 0 ? (
              <div className="text-[11px] text-slate-500 mt-1">
                既存出現店舗:{n.matched_competitors.map((c, i) => (
                  <span key={i} className="ml-1">{c.title}（{c.rank}位）</span>
                ))}
              </div>
            ) : (
              <div className="text-[11px] text-leaf-700 font-semibold mt-1">上位20店舗にキーワード出現なし — 即座に1位を狙えます</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default SubnicheOpportunities;
